<template>
  <v-container fluid fill-width class="pa-0 ma-0">
    <v-row class="ma-0 pa-0">
      <v-col cols="12" class="ma-0 pa-0">
        <v-chip
          v-if="showHelpChip"
          label
          close
          color="#4caf50"
          class="font-weight-bold white--text pa-2 my-1"
          @click:close="showHelpChip = false"
          >Click on bar to toggle category inclusion OR use checkboxes
          below.</v-chip
        >

        <!-- <v-checkbox
          :style="'display: none;'"
          hide-details
          label="placeholder"
          class="pa-0 ma-0 mt-1"
        >
        </v-checkbox> -->
        <svg ref="chart" :width="width" :height="height">
          <g
            v-xaxis="xAxis"
            :transform="`translate(${margin.left},${h + margin.top})`"
          ></g>
          <g
            v-yaxis="yAxis"
            :transform="`translate(${margin.left}, ${margin.top})`"
          ></g>
          <g
            v-if="width && height"
            ref="bars"
            :transform="`translate(${margin.left}, ${margin.top})`"
          >
            <bar-rect
              v-for="d in displayedBarChartData"
              :key="'pd' + d.key"
              :x="xScale(displayedCatNames[d.key])"
              :y="yScale(populationData_d[d.key])"
              :width="xScale.bandwidth()"
              :height="
                h - yScale(populationData_d[d.key]) > 0
                  ? h - yScale(populationData_d[d.key])
                  : 0
              "
              :fill="colors['population']"
              :tooltip="d.key"
              :interactive="interactive"
              @click.native="userClickedBar(d.key)"
            />

            <bar-rect
              v-for="d in displayedBarChartData"
              :key="'d-' + d.key"
              :x="xScale(displayedCatNames[d.key])"
              :y="yScale(data_d[d.key])"
              :width="xScale.bandwidth()"
              :height="
                h - yScale(data_d[d.key]) > 0 ? h - yScale(data_d[d.key]) : 0
              "
              :fill="getFill(d.key)"
              :tooltip="d.key"
              :interactive="interactive"
              @click.native="userClickedBar(d.key)"
            />
          </g>
        </svg>
      </v-col>
    </v-row>

    <v-row v-if="sortedData.length > maxCategoriesShown" class="ma-0 pa-0 pb-2">
      <v-col cols="6" class="pa-0 ma-0 pt-1 pr-3" align="right">
        <span class="pl-2">show top {{ maxCategoriesShown }} by:</span>
      </v-col>
      <v-col cols="6" class="center-text pa-0 ma-0 pr-2">
        <v-select
          v-model="maxCatsDisplayTopN"
          dense
          hide-details
          :items="['population', 'study group']"
          class="pb-2"
        ></v-select>
      </v-col>
    </v-row>

    <!-- interactive mode -->
    <v-row v-if="interactive" class="ma-0 pa-0">
      <v-col cols="12" class="center-text pa-0 ma-0">
        <v-tabs v-model="tab">
          <v-tab key="cats">Manual</v-tab>
          <v-tab
            key="predef"
            :disabled="sortedData.length > maxCategoriesForPredefinedGroups"
            >Pre-defined Groups</v-tab
          >
        </v-tabs>

        <v-tabs-items v-model="tab">
          <!-- selected categories -->
          <v-tab-item key="cats">
            <v-list dense class="pa-0 ma-0 mt-2">
              <v-list-item
                v-for="(d, dn) in displayedBarChartData"
                :key="d.key"
              >
                <v-list-item-content class="py-1">
                  <v-checkbox
                    v-model="cat_cbs"
                    dense
                    hide-details
                    :label="
                      (tooManyCats && !showAllCats ? dn + 1 + '. ' : '') + d.key
                    "
                    :value="d.key"
                  ></v-checkbox>

                  <v-list-item-title
                    v-if="false"
                    v-text="
                      (tooManyCats && !showAllCats ? dn + 1 + '. ' : '') + d.key
                    "
                  ></v-list-item-title>
                </v-list-item-content>

                <v-list-item-action>
                  <v-chip
                    small
                    label
                    color="primary"
                    class="white--text title pa-2 pr-0 pl-1"
                    align="end"
                    justify="center"
                    >{{
                      selected.length && !selected.includes(d.key)
                        ? 0
                        : data_d[d.key]
                    }}
                    /
                    <v-chip
                      small
                      label
                      :color="colors['population']"
                      class="black--text title pa-2 ml-1 mr-0"
                      align="end"
                      justify="center"
                      >{{ populationData_d[d.key] }}</v-chip
                    ></v-chip
                  >
                </v-list-item-action>
              </v-list-item>

              <v-list-item v-if="sortedData.length > maxCategoriesShown">
                <v-list-item-icon class="ma-0 pa-0" justify="end">
                  <v-btn v-if="interactive" @click="openDialog()">{{
                    showAllCats
                      ? 'show top ' + maxCategoriesShown + ' only'
                      : '+ ' +
                        (sortedData.length - displayedData.length) +
                        ' more'
                  }}</v-btn>
                  <span v-else class="pt-1">
                    {{
                      showAllCats
                        ? 'show top ' + maxCategoriesShown + ' only'
                        : '+ ' +
                          (sortedData.length - displayedData.length) +
                          ' more'
                    }}
                  </span>
                </v-list-item-icon>
                <v-list-item-content class="pa-0 ma-0">
                  <v-list-item-title
                    align="end"
                    justify="center"
                    valign="center"
                  >
                    <v-chip
                      small
                      label
                      color="primary"
                      class="white--text title pa-2 pr-0 pl-1"
                      align="end"
                      justify="center"
                      >{{ notDisplayedCount }} /
                      <v-chip
                        small
                        label
                        :color="colors['population']"
                        class="black--text title pa-2 ml-1 mr-0"
                        align="end"
                        justify="center"
                        >{{ notDisplayedPopCount }}</v-chip
                      ></v-chip
                    >
                  </v-list-item-title>
                </v-list-item-content>
              </v-list-item>
            </v-list>
          </v-tab-item>

          <!-- pre-defined groups -->
          <v-tab-item key="predef">
            <v-container fill-width class="pa-0 mx-3 mt-2">
              <v-row class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0 pt-2">
                  Save study groups for:
                  <v-radio-group
                    v-model="predefRadio"
                    hide-details
                    row
                    class="pa-2 my-1 pb-0"
                  >
                    <v-radio value="all" label="All subgroups"></v-radio>
                    <v-radio
                      value="one"
                      label="A single subgroup and all others"
                      :disabled="sortedData.length <= 2"
                    ></v-radio>
                  </v-radio-group>
                </v-col>
              </v-row>

              <!-- single category and its inverse -->
              <v-row v-if="predefRadio === 'one'" class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0 pl-2 pt-3 pr-5">
                  <v-select
                    v-model="predefCategory"
                    :items="sortedData.map(d => d.key)"
                    label="Select subgroup"
                    dense
                  ></v-select>
                </v-col>
              </v-row>

              <!-- all categories over a certain size -->
              <v-row v-if="predefRadio === 'all'" class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0 pt-2">
                  <!--
                  Minimum category size:
                  <v-select
                    v-model="predefMinCategorySize"
                    :items="[1, 5, 10, 20, 50]"
                    label="minimum category size"
                    class="pa-0 ma-0 pt-3"
                    dense
                    ></v-select>
                  -->
                </v-col>
              </v-row>

              <v-row class="pa-0 ma-0">
                <v-col cols="12" class="pa-0 ma-0 pb-1">
                  <v-btn
                    class="primary text--white ma-0 px-2 mx-1 py-0"
                    :disabled="
                      (predefRadio === 'one' && predefCategory === null) ||
                        outputVariables.length == 0
                    "
                    @click="savePredefGroups"
                    >Save groups</v-btn
                  >
                </v-col>
              </v-row>
            </v-container>
          </v-tab-item>
        </v-tabs-items>

        <v-dialog v-model="showDialog" scrollable max-width="80%" height="80%">
          <v-card class="rounded-lg" style="border: 3px solid #3f51b5;">
            <v-card-title color="white" class="ma-0 pa-2" primary-title>
              <span class="primary--text text--darken-3 title">{{
                dimensionName
              }}</span>
            </v-card-title>

            <v-divider></v-divider>

            <v-card-text class="py-4">
              <v-text-field
                v-model="tableSearchText"
                label="Search:"
                dense
                hide-details
                clearable
                class="pt-2 pl-2"
              ></v-text-field>

              <v-data-table
                v-model="table_cbs"
                show-select
                :items="
                  populationData.map(d => {
                    return {
                      key: d.key,
                      description: getCatDescription(d.key),
                      group: data_d[d.key],
                      pop: populationData_d[d.key],
                    };
                  })
                "
                item-key="key"
                :headers="tableHeaders"
                :items-per-page="20"
                :search="tableSearchText"
                dense
                class="mt-5"
              >
                <template v-if="false" v-slot:item.group="{ item }">
                  <td class="subtitle-1 text-xs-left">
                    {{
                      selected.length && !selected.includes(item.key)
                        ? 0
                        : data_d[item.key]
                    }}
                  </td>
                </template>

                <template v-if="false" v-slot:item.pop="{ item }">
                  <td class="subtitle-1 text-xs-left">
                    {{ populationData_d[item.key] }}
                  </td>
                </template>
              </v-data-table>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn color="primary" text @click="showDialog = false"
                ><v-icon left dark>close</v-icon>Close</v-btn
              >
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-col>
    </v-row>
    <!-- non-interactive mode -->
    <v-row v-if="!interactive" class="ma-0 pa-0">
      <v-col cols="12" class="center-text pa-0 ma-0">
        <v-list class="pa-0 ma-0" dense>
          <v-list-item
            v-for="(d, dn) in displayedBarChartData"
            :key="d.key"
            class="my-0 py-0"
          >
            <v-list-item-content class="py-0 ma-0">
              <v-list-item-title
                class="text-body-1 pa-0 ma-0"
                v-text="
                  (tooManyCats && !showAllCats ? dn + 1 + '. ' : '') + d.key
                "
              ></v-list-item-title>
            </v-list-item-content>

            <v-list-item-action>
              <v-chip
                small
                label
                color="primary"
                class="white--text title pa-0 pl-1 ma-0"
                align="end"
                justify="center"
                >{{
                  selected.length && !selected.includes(d.key)
                    ? 0
                    : data_d[d.key]
                }}
                /
                <v-chip
                  small
                  label
                  :color="colors['population']"
                  class="black--text title pa-2 ml-1 mr-0"
                  align="end"
                  justify="center"
                  >{{ populationData_d[d.key] }}</v-chip
                ></v-chip
              >
            </v-list-item-action>
          </v-list-item>

          <v-list-item v-if="sortedData.length > maxCategoriesShown">
            <v-list-item-icon class="ma-0 pa-0" justify="end">
              <v-btn v-if="interactive" @click="openDialog()">{{
                showAllCats
                  ? 'show top ' + maxCategoriesShown + ' only'
                  : '+ ' + (sortedData.length - displayedData.length) + ' more'
              }}</v-btn>
              <span v-else class="pt-1">
                {{
                  showAllCats
                    ? 'show top ' + maxCategoriesShown + ' only'
                    : '+ ' +
                      (sortedData.length - displayedData.length) +
                      ' more'
                }}
              </span>
            </v-list-item-icon>
            <v-list-item-content class="pa-0 ma-0">
              <v-list-item-title align="end" justify="center" valign="center">
                <v-chip
                  small
                  label
                  color="primary"
                  class="white--text title pa-2 pr-0 pl-1"
                  align="end"
                  justify="center"
                  >{{ notDisplayedCount }} /
                  <v-chip
                    small
                    label
                    :color="colors['population']"
                    class="black--text title pa-2 ml-1 mr-0"
                    align="end"
                    justify="center"
                    >{{ notDisplayedPopCount }}</v-chip
                  ></v-chip
                >
              </v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
// Data Store
import { mapState, mapActions, mapGetters } from 'vuex';
import { state, actions, getters } from '@/store/modules/cohortManager/types';

import {
  axisOrdinalBottom,
  axisLeft,
  axisLabelOffset,
  axisLabelRotate,
} from 'd3fc';

// D3 Modules
import { max } from 'd3-array';
import { select } from 'd3-selection';
import { scaleLinear, scaleBand, scaleOrdinal } from 'd3-scale';
import 'd3-transition';
import { schemeCategory10 } from 'd3-scale-chromatic';

import resize from 'vue-resize-directive';
import { colors } from '@/utils/colors';
import { sortByCategory } from '@/utils/categorical_vars';
import BarRect from './BarRect.vue';

const PX_PER_LABEL_LINE = 15;
const N_LABEL_LINES = 4;
// set one but not both of these to true:
const ROTATE_LABELS = false;
const OFFSET_LABELS = true;

export default {
  directives: {
    resize,
    xaxis(el, binding) {
      const axisMethod = binding.value;
      select(el).call(axisMethod);
      // .selectAll('path')
      // .attr('stroke', '#E8EAF6')
      // .attr('stroke-width', 3);
    },
    yaxis(el, binding) {
      const axisMethod = binding.value;
      select(el)
        // .transition()
        .call(axisMethod);
      // .selectAll('path')
      // .attr('stroke', '#E8EAF6')
      // .attr('stroke-width', 3);
    },
  },
  components: {
    BarRect,
  },
  props: {
    id: {
      type: [Number, String],
      required: true,
    },
    dimensionName: {
      type: String,
      required: true,
    },
    variable: {
      type: Object,
      required: false,
      default: null,
    },
    showFilterHelp: {
      type: Boolean,
      required: false,
      default: false,
    },
    maxCategoriesShown: {
      type: Number,
      required: false,
      default: 10,
    },
    maxCategoriesForPredefinedGroups: {
      type: Number,
      required: false,
      default: 20,
    },
    interactive: {
      type: Boolean,
      required: false,
      default: true,
    },
  },
  data() {
    return {
      isLoading: true,
      haveDimensions: false,
      width: 0,
      height: 0,
      margin: {
        top: 10,
        right: 30,
        bottom: 0,
        left: 50,
      },
      selected: [],
      container: null,
      dimension: null,
      group: [],
      data: [],
      data_d: {},
      populationData: [],
      populationData_d: {},
      colors: colors,
      // current tab
      tab: 'cats',
      // category checkboxes
      cat_cbs: [],
      showHelpChip: false,
      predefRadio: 'all',
      predefMinCategorySize: 1,
      predefCategory: null,
      showAllCats: false,
      maxCatsDisplayTopN: 'population',
      showDialog: false,
      tableSearchText: '',
      table_cbs: [],
    };
  },
  computed: {
    ...mapGetters('cohortManager', {
      findCohortQuery: getters.FIND_COHORT_QUERY,
      hasUserSelectedCohort: getters.HAS_USER_SELECTED_COHORT,
    }),
    ...mapState('cohortManager', {
      filteredData: state.FILTERED_DATA,
      unfilteredData: state.UNFILTERED_DATA,
      dimensions: state.DIMENSIONS,
      cohort: state.COHORT,
      collection: state.COLLECTION,
      inputVariables: state.INPUT_VARIABLES,
      outputVariables: state.OUTPUT_VARIABLES,
      useLongScaleNames: state.USE_LONG_SCALE_NAMES,
      cvMetadata: state.CV_METADATA,
      selectedAnalysisMode: state.SELECTED_ANALYSIS_MODE,
    }),
    w() {
      const { left, right } = this.margin;
      const { width } = this;
      return width - left - right;
    },
    h() {
      const { top, bottom } = this.margin;
      const { height } = this;
      return height - top - bottom - (N_LABEL_LINES - 1) * PX_PER_LABEL_LINE;
    },
    colorScale() {
      return scaleOrdinal()
        .domain(this.data.map(c => c.key))
        .range(schemeCategory10);
    },
    sortedPopulationData() {
      return sortByCategory(
        this.variable,
        [...this.populationData],
        a => a.key
      );
    },
    displayedPopulationData() {
      let sd = this.sortedPopulationData;
      if (this.tooManyCats && !this.showAllCats) {
        let sortFn = function(a, b) {
          if (b.value == a.value) {
            return a.key.localeCompare(b.key);
          }
          return b.value - a.value;
        };
        let sortedByCount = [...this.populationData].sort(sortFn);
        return sortedByCount.slice(0, this.maxCategoriesShown);
      }
      return sd;
    },
    sortedData() {
      return sortByCategory(this.variable, [...this.data], a => a.key);
    },
    displayedBarChartData() {
      return this.maxCatsDisplayTopN == 'population'
        ? this.displayedPopulationData
        : this.displayedData;
    },
    displayedCatNames() {
      let dd = {};
      let sd = this.sortedPopulationData;
      if (this.tooManyCats && !this.showAllCats) {
        let sd = this.displayedBarChartData;
        let ct = 0;
        sd.map(d => (dd[d.key] = ++ct));
      } else {
        sd.map(d => (dd[d.key] = d.key));
      }
      return dd;
    },
    displayedData() {
      let sd = this.sortedData;
      if (this.tooManyCats && !this.showAllCats) {
        let ns = this.selected.length;
        let sel_d = {};
        this.selected.forEach(s => {
          sel_d[s] = 1;
        });

        let sortFn = function(a, b) {
          let av = ns > 0 && !(a.key in sel_d) ? 0.0 : a.value;
          let bv = ns > 0 && !(b.key in sel_d) ? 0.0 : b.value;

          if (av == bv) {
            return a.key.localeCompare(b.key);
          }
          return bv - av;
        };
        let sortedByCount = [...this.data].sort(sortFn);
        return sortedByCount.slice(0, this.maxCategoriesShown);
      }
      return sd;
    },
    notDisplayedPopCount() {
      let popCount = 0;

      // displayed categories
      let disp_d = {};
      this.displayedBarChartData.forEach(d => {
        disp_d[d.key] = 1;
      });

      this.populationData.forEach(d => {
        if (!(d.key in disp_d)) {
          popCount += this.populationData_d[d.key];
        }
      });

      return popCount;
    },
    notDisplayedCount() {
      let count = 0;
      let ns = this.selected.length;
      let sel_d = {};
      // selected categories
      this.selected.forEach(s => {
        sel_d[s] = 1;
      });

      // displayed categories
      let disp_d = {};
      this.displayedBarChartData.forEach(d => {
        disp_d[d.key] = 1;
      });

      this.populationData.forEach(d => {
        if (!(d.key in disp_d)) {
          if (d.key in sel_d || ns == 0) {
            count += this.data_d[d.key];
          }
        }
      });

      return count;
    },
    tooManyCats() {
      return this.sortedPopulationData.length > this.maxCategoriesShown;
    },
    xScale() {
      let cats = [];
      if (this.tooManyCats) {
        let ncats = this.displayedBarChartData.length;
        for (let cn = 1; cn <= ncats; ++cn) {
          cats.push(cn);
        }
      } else {
        cats = this.displayedBarChartData.map(d => d.key);
      }
      return scaleBand()
        .domain(cats)
        .range([0, this.w])
        .padding(0.05);
    },
    yScale() {
      return scaleLinear()
        .domain([0, max(this.populationData, d => d.value)])
        .range([this.h, 0]);
    },
    xAxis() {
      var xaxis = null;
      if (ROTATE_LABELS) {
        xaxis = axisLabelRotate(axisOrdinalBottom(this.xScale));
        if (this.populationData.map(d => d.key).length > 2) {
          xaxis.labelRotate(18);
        }
      } else if (OFFSET_LABELS) {
        xaxis = axisLabelOffset(axisOrdinalBottom(this.xScale));
      }
      return xaxis;
    },
    yAxis() {
      return axisLeft(this.yScale).ticks(5);
    },
    tableHeaders() {
      let th = [];
      th.push({
        text: 'Category',
        align: 'start',
        sortable: true,
        value: 'key',
      });

      if (
        this.dimensionName.startsWith('ICD10_Code_') &&
        'ICD10_Code' in this.cvMetadata
      ) {
        th.push({
          text: 'Description',
          align: 'start',
          sortable: true,
          value: 'description',
        });
      }

      th.push({
        text: 'Study Group',
        align: 'start',
        sortable: true,
        value: 'group',
      });
      th.push({
        text: 'Population',
        align: 'start',
        sortable: true,
        value: 'pop',
      });
      return th;
    },
  },
  watch: {
    dimensionName() {
      const dimension = this.dimensions[this.dimensionName];
      this.dimension = dimension;
      this.group = dimension.group();
      this.data = this.group.all();

      var popCounts = {};
      this.unfilteredData.forEach(d => {
        var v = dimension.accessor(d);

        if (!(v in popCounts)) {
          popCounts[v] = 0;
        }
        popCounts[v] += 1;
      });
      var popData = [];
      for (var k in popCounts) {
        var c = popCounts[k];
        popData.push({ key: k, value: c });
      }
      this.populationData = popData;
      this.populationData_d = popCounts;
      this.updateSelectionFromCohortQuery();
      this.updateDataDict();
    },
    filteredData() {
      this.data = this.group.all();
      if (this.selected.length && !this.dimension.currentFilter()) {
        this.selected = [];
        this.cat_cbs = [];
      }
      this.updateDataDict();
    },
    cohort() {
      this.updateSelectionFromCohortQuery();
    },
    selected(new_sel) {
      var sel_h = {};
      new_sel.forEach(s => {
        sel_h[s] = true;
      });
      // update checkboxes to match
      var new_cat_cbs = [];
      this.data.forEach(d => {
        var sel = sel_h[d.key];
        if (sel) new_cat_cbs.push(d.key);
      });
      this.cat_cbs = new_cat_cbs;
    },
    // category checkboxes modified
    cat_cbs(new_cbs) {
      // selected bars
      var sel_b = {};
      this.selected.forEach(s => {
        sel_b[s] = true;
      });

      // selected checkboxes
      var sel_c = {};
      new_cbs.forEach(s => {
        sel_c[s] = true;
      });

      // compare checkbox state with current selection
      this.data.forEach(d => {
        var k = d.key;
        var bar_sel = sel_b[k];
        var cb_val = sel_c[k];

        if (cb_val && !bar_sel) {
          this.selectOrDeselectBar(k);
        } else if (!cb_val && bar_sel) {
          this.selectOrDeselectBar(k);
        }
      });
    },
    table_cbs(new_cbs) {
      this.cat_cbs = new_cbs.map(d => d.key);
    },
    showFilterHelp(show) {
      this.showHelpChip = show;
    },
  },
  created() {
    const dimension = this.dimensions[this.dimensionName];
    this.dimension = dimension;
    this.group = dimension.group();
    this.data = this.group.all();

    var popCounts = {};
    this.unfilteredData.forEach(d => {
      var v = dimension.accessor(d);

      if (!(v in popCounts)) {
        popCounts[v] = 0;
      }
      popCounts[v] += 1;
    });
    var popData = [];
    for (var k in popCounts) {
      var c = popCounts[k];
      popData.push({ key: k, value: c });
    }
    this.populationData = popData;
    this.populationData_d = popCounts;
    this.updateSelectionFromCohortQuery();
    this.updateDataDict();
  },
  destroyed() {
    this.clearFilter({
      dimension: this.dimensionName,
    });
  },
  mounted() {
    this.container = this.$refs.container;
    this.resizeChart();
  },
  methods: {
    ...mapActions('cohortManager', {
      addFilter: actions.ADD_FILTER,
      clearFilter: actions.CLEAR_FILTER,
      saveCohort: actions.SAVE_COHORT,
    }),
    getFill(key) {
      if (!this.selected.length || this.selected.includes(key)) {
        return colors['cohort'];
      }
      return colors['population'];
    },
    selectBar(key) {
      // already selected
      if (this.selected.includes(key)) {
        return;
      }
      this.selectOrDeselectBar(key);
    },
    deselectBar(key) {
      // already deselected
      if (!this.selected.includes(key)) {
        return;
      }
      this.selectOrDeselectBar(key);
    },
    selectOrDeselectBar(key) {
      if (this.selected.includes(key)) {
        this.selected = this.selected.filter(d => d !== key);
      } else {
        this.selected.push(key);
      }

      if (this.selected.length) {
        this.addFilter({
          dimension: this.dimensionName,
          filter: d => this.selected.includes(d),
          query: this.selected.map(k => ({
            value: k,
          })),
        });
      } else {
        this.clearFilter({
          dimension: this.dimensionName,
        });
      }
    },
    userClickedBar(key) {
      if (this.interactive) {
        this.selectOrDeselectBar(key);
        this.$emit('userChangedVariable', this.dimensionName);
      }
    },
    resizeChart() {
      this.height = 140;
      this.width = 350;
    },
    updateSelectionFromCohortQuery() {
      // If there is a cohort selected then apply the appropriate
      // queries to the chart
      if (this.hasUserSelectedCohort) {
        const queries = this.findCohortQuery(this.dimensionName);
        // we want to delay updating the chart a cycle until
        // the chart is actually mounted to the DOM
        this.$nextTick(() => {
          queries.forEach(queryForThisChart =>
            this.selectOrDeselectBar(queryForThisChart.value)
          );
        });
      }
    },
    async savePredefGroups() {
      // map category to data/subjects and count
      var cat2d = {};
      var cat2c = {};
      this.unfilteredData.map(d => {
        let dv = this.dimension.accessor(d);
        if (!(dv in cat2d)) {
          cat2d[dv] = [];
          cat2c[dv] = 0;
        }
        cat2d[dv].push(d);
        cat2c[dv] += 1;
      });

      var s_args = {
        collection: this.collection,
        inputVariables: this.inputVariables,
        outputVariables: this.outputVariables,
        minCatSize: 1,
      };
      let varName = null;
      // first or last visit for longitudinal var
      if (this.variable.label.match(/first visit|last visit/i)) {
        varName = this.dimensionName;
      }
      // all others
      else {
        varName = this.useLongScaleNames
          ? this.variable.label
          : this.variable.abbreviation;
      }

      if (this.selectedAnalysisMode == 'Outcome based') {
        varName = '[O]_' + varName;
      }

      // study groups to save
      var groups = [];

      // inverse of single selected group
      var invQueries = [];
      invQueries[this.dimensionName] = [];
      var invSubjIds = [];

      this.sortedData
        .map(d => d.key)
        .forEach(cat => {
          var queries = {};
          var query = { value: cat };
          queries[this.dimensionName] = [query];
          var subjIds = cat2d[cat].map(d => d.subject_id);
          var args = {
            name: varName + ' - ' + cat,
            queries: queries,
            subjectIds: subjIds,
            ...s_args,
          };
          if (this.predefRadio === 'all' || cat === this.predefCategory) {
            groups.push(args);
          } else if (cat !== this.predefCategory) {
            invQueries[this.dimensionName].push(query);
            invSubjIds = invSubjIds.concat(subjIds);
          }
        });

      // save inverse of selected category
      if (this.predefRadio === 'one') {
        var args = {
          name: varName + ' - NOT ' + this.predefCategory,
          queries: invQueries,
          subjectIds: invSubjIds,
          ...s_args,
        };
        groups.push(args);
      }

      // create groups in reverse order so final order will match categories below/in chart
      var nGroups = groups.length;
      for (var g = nGroups - 1; g >= 0; g--) {
        const group = groups[g];
        await this.saveCohort(group);
      }
    },
    openDialog() {
      // copy over current checkbox state
      let cat_cbs_d = {};
      this.cat_cbs.forEach(k => {
        cat_cbs_d[k] = 1;
      });
      let table_cbs = [];
      this.populationData.forEach(pd => {
        if (pd.key in cat_cbs_d) {
          table_cbs.push(pd);
        }
      });
      this.table_cbs = table_cbs;
      this.showDialog = true;
    },
    updateDataDict() {
      let data_d = {};
      let ns = this.selected.length;
      let sel_d = {};
      this.selected.forEach(s => {
        sel_d[s] = 1;
      });
      this.data.forEach(d => {
        data_d[d.key] = ns > 0 && !(d.key in sel_d) ? 0.0 : d.value;
      });
      this.data_d = data_d;
    },
    getCatDescription(cat) {
      if (
        this.dimensionName.startsWith('ICD10_Code_') &&
        'ICD10_Code' in this.cvMetadata
      ) {
        let mcat = cat.replace('.', '');
        if (mcat in this.cvMetadata['ICD10_Code']) {
          return this.cvMetadata['ICD10_Code'][mcat];
        }
      }
      return '';
    },
  },
};
</script>

<style lang="scss" scoped>
div.v-input--checkbox {
  padding: 0px;
}
</style>
